import "./policy.css";

export default function Returns() {

  return (
    <div className="policy-page">

      <div className="policy-hero">
        <h1>Return Policy</h1>
        <p>Simple and customer-friendly returns.</p>
      </div>

      <div className="policy-container">

        <div className="policy-card">
          <h2>Return Eligibility</h2>

          <p>
            Products may be returned within 7 days
            after delivery if unused and unopened.
          </p>
        </div>

        <div className="policy-card">
          <h2>Damaged Products</h2>

          <p>
            If your order arrives damaged, contact our
            support team immediately for assistance.
          </p>
        </div>

        <div className="policy-card">
          <h2>Refund Processing</h2>

          <p>
            Approved refunds are processed within
            5-7 business days.
          </p>
        </div>

      </div>

    </div>
  );
}